import {takeLatest, put, all} from 'redux-saga/effects';
import * as fromApi from '../../../lib/api/musiconline.api';

function* watchGetDatasusers(action) {
	try {
		const result = yield fromApi.dataUsersGets(action.token).then((data) => {
			return data;
		});
		yield put({type: 'GET_DATASUSERS_RETURN', payload: result});
	} catch (error) {
		yield put({
			type: 'ERROR',
			error: true,
			payload: error
		});
	}
}

function* datausers() {
	yield takeLatest('GET_DATASUSERS_SAGAS', watchGetDatasusers);
}

export default function* rootSaga() {
	yield all([datausers()]);
}
